// File: `app/javascript/controllers/product_module/horseback.js`
import $ from 'jquery';
import flatpickr from 'flatpickr';
import {withElementBlock} from "../blockUI_controller";

export function initHorseback(deps = {}) {
    const {
        form_type_send,
        create_array_for_product,
        get_contract,
        modalities,
        modality_info,
        setSessionVar,
        date_disabled,
        flatpick_lang,
        I18n,
        location,
        sessionStorage
    } = deps;

    if (!form_type_send) return;

    const horseback_to = $('#horseback_to');
    const horseback_service = $('#horseback_service');
    const horseback_date = $('#horseback_date');
    const horseback_cantidad = $('#horseback_cantidad');
    const horseback_observaciones = $('#horseback_observaciones');

    // Estado inicial
    horseback_service.prop('disabled', true).select2({
        theme: 'bootstrap',
        placeholder: I18n.t('global.main.form.select_service')
    });
    horseback_date.prop('disabled', true);
    horseback_cantidad.prop('disabled', true);
    horseback_observaciones.prop('disabled', true);

    // Destinos
    horseback_to.select2({
        theme: "bootstrap",
        placeholder: I18n.t('global.main.form.select_destiny'),
        ajax: {
            url: '/destination',
            dataType: "json",
            language: "es",
            data: function (params) {
                return {
                    form_type: form_type_send.val(),
                    search: params.term,
                    page: params.page || 1
                };
            },
            type: 'GET',
            processResults: function (data, params) {
                params.page = params.page || 1;
                const result = (data.rows || []).map(elem => ({
                    id: `${elem.code}|${elem.id}|${elem.name}`,
                    text: elem.name
                }));
                const total = data.total || 0;
                return {
                    results: result,
                    pagination: { more: total > 10 && ((parseInt(total) - (10 * parseInt(params.page || 1))) > 1) }
                };
            }
        }
    }).on('change', function (e) {
        const parts = (e.target.value || '').split('|');
        const destino_id = parts[1] || '';

        create_array_for_product('product_type', form_type_send.val());
        create_array_for_product('destination_id', destino_id);
        create_array_for_product('destination_code', parts[0] || '');
        create_array_for_product('text_destination', parts[2] || '');

        // limpiar
        horseback_service.empty();
        horseback_date.val('');
        horseback_cantidad.val('');
        horseback_observaciones.val('');

        // Servicios por dealer
        horseback_service.prop('disabled', false).select2({
            theme: "bootstrap",
            placeholder: I18n.t('global.main.form.select_service'),
            ajax: {
                url: `${location.origin}/${sessionStorage.getItem('locale')}/service_by_dealer`,
                dataType: "json",
                language: "es",
                data: function (params) {
                    return {
                        destination: destino_id,
                        form_type: form_type_send.val(),
                        search: params.term,
                        page: params.page || 1
                    };
                },
                type: 'GET',
                processResults: function (data, params) {
                    params.page = params.page || 1;
                    const result = (data.rows || []).map(elem => ({
                        id: `${elem.category_id}|${elem.category_code}|${elem.reservation_time}|${elem.dealer_code}|${elem.dealer_name}|${elem.dealer_id}`,
                        text: elem.name
                    }));
                    const total = data.total || 0;
                    return {
                        results: result,
                        pagination: { more: total > 10 && ((parseInt(total) - (10 * parseInt(params.page || 1))) > 1) }
                    };
                }
            }
        }).on('change', function (e) {
            horseback_date.prop('disabled', false);
            horseback_cantidad.prop('disabled', false);
            horseback_observaciones.prop('disabled', false);

            const product_type = (e.target.value || '').split("|");
            const product_name = (e.target.selectedOptions && e.target.selectedOptions[0] && e.target.selectedOptions[0].innerHTML || '').toLowerCase();

            create_array_for_product('category_id', product_type[0]);
            create_array_for_product('category_code', product_type[1]);
            create_array_for_product('dealer_code', product_type[3]);
            create_array_for_product('dealer_name', product_type[4]);
            create_array_for_product('dealer_id', product_type[5]);

            // Obtener contrato si hace falta (con bloqueo + desbloqueo garantizado)
            if (typeof get_contract === 'function') {
                withElementBlock('box-form', I18n.t('global.main.form.message.search_contract'), get_contract('box-form')).then(gcontract => {
                    if (!gcontract.next) return;
                });
            }

            // Obtener modalidades y detalle de modalidad por defecto
            if (typeof modalities === 'function' && typeof modality_info === 'function') {
                withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                    modalities(product_type[0], product_type[5]),
                    { timeout: 30000 }
                ).then(mdlt => {
                    const defaultModal = (mdlt && mdlt.rows && mdlt.rows[0]) ? mdlt.rows[0].name : '';
                    if (defaultModal) {
                        withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                            modality_info(product_type[5], product_type[0], defaultModal),
                            { timeout: 30000 }
                        ).then(modality => {
                            // opcional: manejar detalle de modalidad si es necesario
                            if (modality && modality.rows && modality.rows[0]) {
                                create_array_for_product('modalities_name', defaultModal);
                            }
                        });
                    }
                });
            }

            // Calendario
            flatpickr(horseback_date, {
                altInput: true,
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d",
                disable: date_disabled,
                minDate: new Date().fp_incr(parseInt(product_type[2] || 0)),
                maxDate: new Date().fp_incr(90),
                locale: flatpick_lang
            });

            horseback_date.off('change').on('change', function (ev) {
                // Guardar fechas en session y en array de producto
                setSessionVar('from_date', ev.target.value, 'add', true, false).then(from => {
                    create_array_for_product('from_date', from.value);
                });
                setSessionVar('to_date', ev.target.value, 'add', true, false, 1).then(to => {
                    create_array_for_product('to_date', to.value);
                });
            });
        });
    });
}



/* Antes de dividir */
/*
let horseback_to, horseback_service, horseback_date, horseback_cantidad, horseback_observaciones;
horseback_to = $('#horseback_to');
horseback_service = $('#horseback_service');
horseback_date = $('#horseback_date');
horseback_cantidad = $('#horseback_cantidad');
horseback_observaciones = $('#horseback_observaciones');
horseback_service.prop('disabled', true).select2({
    theme: 'bootstrap',
    placeholder: I18n.t('global.main.form.select_service')
});
horseback_date.prop('disabled', true);
horseback_cantidad.prop('disabled', true);
horseback_observaciones.prop('disabled', true);

horseback_to.select2({
    theme: "bootstrap",
    placeholder: I18n.t('global.main.form.select_destiny'),
    ajax: {
        url: '/destination',
        dataType: "json",
        language: "es",
        data: function (params) {
            return {
                form_type: form_type_send.val(),
                search: params.term,
                page: params.page || 1
            }
        },
        type: 'GET',
        processResults: function (data, params) {
            let result = [];
            params.page = params.page || 1;

            data.rows.map((elem, key) => {
                result.push({
                    id: elem.code + '|' + elem.id + '|' + elem.name,
                    text: elem.name
                })
            })

            if (data.total > 10) {
                if ((parseInt(data.total) - (10 * parseInt(params.page))) > 1) {
                    return {
                        results: result,
                        "pagination": {
                            "more": true
                        }
                    }
                } else {
                    return {
                        results: result,
                        "pagination": {
                            "more": false
                        }
                    }
                }
            } else {
                return {
                    results: result,
                    "pagination": {
                        "more": false
                    }
                }
            }
        }
    }
}).on('change', function (e) {
    let data_horseback_to = e.target.value.split("|")[1];
    create_array_for_product('product_type', form_type_send.val());
    create_array_for_product('destination_id', e.target.value.split("|")[1]);
    create_array_for_product('destination_code', e.target.value.split("|")[0]);
    create_array_for_product('text_destination', e.target.value.split("|")[2]);

    horseback_service.empty();
    horseback_date.empty();
    horseback_cantidad.empty();
    horseback_observaciones.empty();

    horseback_service.prop('disabled', false).select2({
        theme: "bootstrap",
        placeholder: I18n.t('global.main.form.select_service'),
        ajax: {
            url: `${location.origin}/${sessionStorage.getItem('locale')}/service_by_dealer`,
            data: function (params) {
                return {
                    search: params.term,
                    page: params.page || 1,
                    destination: data_horseback_to,
                    form_type: form_type_send.val()
                }
            },
            type: 'GET',
            processResults: function (data, params) {
                let result = [];
                params.page = params.page || 1;
                data.services.map((elem, key) => {
                    result.push({
                        id: elem.id + "|" + elem.code + "|" + elem.reservation_time + "|" + data.dealer_code + "|" + data.dealer_name + "|" + data.dealer_id + "|" + elem.min_reservation_amount + "|" + elem.max_reservation_amount,
                        text: elem.name
                    })
                })

                if (data.total > 10) {
                    if ((parseInt(data.total) - (10 * parseInt(params.page))) > 1) {
                        return {
                            results: result,
                            "pagination": {
                                "more": true
                            }
                        }
                    } else {
                        return {
                            results: result,
                            "pagination": {
                                "more": false
                            }
                        }
                    }
                } else {
                    return {
                        results: result,
                        "pagination": {
                            "more": false
                        }
                    }
                }
            }
        }
    }).on('change', function (e) {
        horseback_date.prop('disabled', false);
        horseback_cantidad.prop('disabled', false);
        horseback_observaciones.prop('disabled', false);

        let product_type = e.target.value.split("|");
        let product_name = '';
        product_name = e.target.selectedOptions[0].innerHTML.toLowerCase();

        create_array_for_product('category_id', product_type[0]);
        create_array_for_product('category_code', product_type[1]);
        create_array_for_product('dealer_code', product_type[3]);
        create_array_for_product('dealer_name', product_type[4]);
        create_array_for_product('dealer_id', product_type[5]);

        get_contract().then(
            contract => {
                // console.log(contract);
            }
        )

        modalities(product_type[0], product_type[5]).then(
            mdlt => {
                /!* REVISAR LUEGO POR EL TEMA DEL NOMBRE DE LA MODALIDAD ESTA PUESTO 'FINCA EL FRUTAL POR PAX' *!/
                let modalities_name = mdlt.rows[0];
                let split_modality = modalities_name.split(' ');
                if (split_modality[split_modality.length - 1] === 'POR') {
                    modalities_name = split_modality.slice(0, -1).join(' ');
                }
                create_array_for_product('modalities_name', modalities_name);

                modality_info(product_type[5], product_type[0], modalities_name).then(
                    modality => {
                        create_array_for_product('modality_code', modality.data[0].code);
                        create_array_for_product('calc_amount', modality.calc_amount);

                        horseback_cantidad[0].setAttribute('data-min', modality.min);
                        horseback_cantidad[0].setAttribute('data-max', modality.max + 20);

                        if (modality.info === 'true') {
                            if (modality.has_pax) {
                                /!* OCULTANDO Y MOSTRANDO INPUTS EN DEPENDENCIA DE LO QUE NOS DEVUELVA EL SERVICIO *!/
                                /!*excursion_pax_block[0].classList.add('ocultar');
                                excursion_cantidad_block[0].classList.add('ocultar');
                                excursion_adult_childrens[0].classList.remove('ocultar');*!/

                                /!* SETEANDO ATRIBUTOS A LOS INPUTS PARA EVALUAR *!/
                                /!*excursion_adultos[0].setAttribute('data-min', modality.min);
                                let min = 1;
                                if ((parseInt(modality.min) - 1) <= 0) {
                                    min = 0
                                }
                                excursion_childrens[0].setAttribute('data-min', min)
                                excursion_adultos[0].setAttribute('data-max', modality.max);
                                excursion_childrens[0].setAttribute('data-max', (parseInt(modality.max) - 1))
                                excursion_adultos[0].setAttribute('data-evaluate-max', modality.max);
                                excursion_childrens[0].setAttribute('data-evaluate-max', modality.max)

                                create_array_for_product('day_min_rent', min);
                                create_array_for_product('day_max_rent', modality.max);*!/
                            } else {
                                /!*excursion_pax_block[0].classList.remove('ocultar');
                                excursion_cantidad_block[0].classList.add('ocultar');
                                excursion_adult_childrens[0].classList.add('ocultar');
                                excursion_pax.prop('disabled', false);*!/
                            }
                        }
                    }
                )
            }
        )

        flatpickr(horseback_date, {
            altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            disable: date_disabled,
            minDate: new Date().fp_incr(parseInt(product_type[2])),
            maxDate: new Date().fp_incr(90),
            locale: flatpick_lang
        });

        horseback_date.on('change', function (e) {
            /!* SETEANDO FECHA EN QUE EMPIEZA Y TERMINA LA EXCURSION *!/
            setSessionVar('from_date', e.target.value, 'add', true, false).then(
                from => {
                    create_array_for_product('from_date', from.value);
                }
            );
            setSessionVar('to_date', e.target.value, 'add', true, false, 1).then(
                to => {
                    create_array_for_product('to_date', to.value);
                }
            );
        })
    })
})*/
